import React, { useState } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import apiConfig from "../apiConfig";

const TpinManage = () => {
  const history = useHistory();

  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;

  const [inpval, setINP] = useState({
    tpin: "",
    oldtpin: "",
    email: userInfo.email,
    user_id: userInfo.user_id,
  });

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [loading, setLoading] = useState(false);

  const setdata = (e) => {
    const { name, value } = e.target;
    setINP((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const addinpdata = async (e) => {
    e.preventDefault();

    const { tpin, oldtpin, email, user_id } = inpval;

    if (!tpin || !oldtpin) {
      alert("All fields required!");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${apiConfig.baseURL}/api/users/TpinManage/${user_id}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ oldtpin, tpin, email, user_id }),
        }
      );

      const data = await res.json();

      if (res.status === 200) {
        alert("Updated Successfully ✅");
        history.push("/admin");
      } else {
        alert(data.msg || "Error ❌");
      }
    } catch (err) {
      alert("Server Error ❌");
    }

    setLoading(false);
  };

  return (
    <>
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body bg-light">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-lg-6">

              <div className="card border-0 shadow-sm">
                
                <div className="card-body p-4 bg-white rounded">

                  <h4 className="mb-4 text-center fw-bold">
                    🔐 Change Security Transaction Pin
                  </h4>

                  <form onSubmit={addinpdata}>

                    {/* OLD PIN */}
                    <div className="mb-3">
                      <label className="form-label">Old Transaction Pin</label>
                      <div className="input-group">
                        <input
                          type={showOld ? "text" : "password"}
                          name="oldtpin"
                          className="form-control"
                          placeholder="Enter old pin"
                          value={inpval.oldtpin}
                          onChange={setdata}
                        />
                        <span
                          className="input-group-text cursor-pointer"
                          onClick={() => setShowOld(!showOld)}
                          style={{ cursor: "pointer" }}
                        >
                          {showOld ? "🙈" : "👁"}
                        </span>
                      </div>
                    </div>

                    {/* NEW PIN */}
                    <div className="mb-4">
                      <label className="form-label">New Transaction Pin</label>
                      <div className="input-group">
                        <input
                          type={showNew ? "text" : "password"}
                          name="tpin"
                          className="form-control"
                          placeholder="Enter new pin"
                          value={inpval.tpin}
                          onChange={setdata}
                        />
                        <span
                          className="input-group-text"
                          onClick={() => setShowNew(!showNew)}
                          style={{ cursor: "pointer" }}
                        >
                          {showNew ? "🙈" : "👁"}
                        </span>
                      </div>
                    </div>

                    {/* BUTTON */}
                    <div className="d-grid">
                      <button
                        type="submit"
                        className="btn btn-dark"
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Update Transaction Pin"}
                      </button>
                    </div>

                  </form>

                </div>

              </div>

            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TpinManage;